import { VolumeDiscountRepository } from "public/repository/volume-discount.repository";

/**
 * @type {{name: string, timestamp: number}}
 */
const metadata = {
  name: "switch-color-from-string-to-object-hex-and-alpha",
  timestamp: new Date("2025-07-18").getTime(),
};

/**
 * Remove empty volume discounts that was created by mistake
 * @param {Object} args
 * @param {Object} args.settings
 * @param {string} args.settings.namespace
 */
async function migrate({ settings }) {
  const volumeDiscountRepository = new VolumeDiscountRepository(settings);
  const volumeDiscounts = await volumeDiscountRepository.getAll();

  if (volumeDiscounts.items.length <= 0) {
    return;
  }

  if (volumeDiscounts.items.length >= 500) {
    console.log(
      `migrate:Volume Discounts collection is too large to migrate`,
      metadata.name
    );
    return;
  }

  for (const volumeDiscount of volumeDiscounts.items) {
    console.log(metadata.name, volumeDiscount, "Checking volume discount");

    // Iterate deep nest volumeDiscount.style and change color from string to object { hex: oldValue, alpha: 1 }
    // volumeDiscount.style is deep nested object, so we need to iterate over all nested objects
    iterateDeepNestObject(volumeDiscount.style, "color");

    await volumeDiscountRepository.update(volumeDiscount);
  }
}

function iterateDeepNestObject(obj, keyName) {
  for (const key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }

    if (typeof obj[key] === "object") {
      iterateDeepNestObject(obj[key], keyName);
      continue;
    }

    if (key !== keyName || typeof obj[key] !== "string") {
      continue;
    }

    const hex = obj[key];

    obj[key] = { hex, alpha: 1 };
  }
}

export default { metadata, migrate };
